import { render, staticRenderFns } from "./finantial-settings-page.vue?vue&type=template&id=206ca948&scoped=true&"
import script from "./finantial-settings-page.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-page.vue?vue&type=style&index=0&id=206ca948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ca948",
  null
  
)

export default component.exports